module.exports = __webpack_public_path__ + "img/12.313004e2.jpg";